import _asyncToGenerator from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { useCallback } from 'react';
import { useGlobalsService } from '@restworld/data-services';
export var useShortenURL = function useShortenURL() {
  var globalServices = useGlobalsService();
  var getShortenURL = useCallback( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
      var _ref$longURL, longURL, _yield$globalServices, _yield$globalServices2, _yield$globalServices3, _yield$globalServices4;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _ref$longURL = _ref.longURL, longURL = _ref$longURL === void 0 ? '' : _ref$longURL;
              _context.prev = 1;
              _context.next = 4;
              return globalServices.createShortenUrl({
                original_url: longURL
              });

            case 4:
              _context.t2 = _yield$globalServices2 = _context.sent;
              _context.t1 = _context.t2 === null;

              if (_context.t1) {
                _context.next = 8;
                break;
              }

              _context.t1 = _yield$globalServices2 === void 0;

            case 8:
              if (!_context.t1) {
                _context.next = 12;
                break;
              }

              _context.t3 = void 0;
              _context.next = 13;
              break;

            case 12:
              _context.t3 = (_yield$globalServices3 = _yield$globalServices2.data) === null || _yield$globalServices3 === void 0 ? void 0 : (_yield$globalServices4 = _yield$globalServices3.data) === null || _yield$globalServices4 === void 0 ? void 0 : _yield$globalServices4.short_url;

            case 13:
              _context.t4 = _yield$globalServices = _context.t3;
              _context.t0 = _context.t4 !== null;

              if (!_context.t0) {
                _context.next = 17;
                break;
              }

              _context.t0 = _yield$globalServices !== void 0;

            case 17:
              if (!_context.t0) {
                _context.next = 21;
                break;
              }

              _context.t5 = _yield$globalServices;
              _context.next = 22;
              break;

            case 21:
              _context.t5 = '';

            case 22:
              return _context.abrupt("return", _context.t5);

            case 25:
              _context.prev = 25;
              _context.t6 = _context["catch"](1);
              console.error("Error shortening the URL", _context.t6);
              return _context.abrupt("return", 'error');

            case 29:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 25]]);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [globalServices]);
  return {
    getShortenURL: getShortenURL
  };
};